import classNames from "classnames";
import { motion } from "framer-motion";
import React from "react";
import JsxParser from "react-jsx-parser";
import { framerMotionAnimation } from "utils/animation";
import styles from "./styles.module.scss";

interface Props {
  className?: string;
  title: string;
  titleClassName?: string;
  type?: "primary" | "secondary";
  subtitle?: string;
  subtitleClassName?: string;
}

const Title: React.FC<Props> = ({
  className,
  title,
  titleClassName,
  type = "primary",
  subtitle,
  subtitleClassName,
}) => {
  return (
    <div className={classNames(styles.container, className)}>
      {title && (
        <motion.h2
          className={classNames(
            styles.title,
            {
              [styles.secondary]: type === "secondary",
            },
            titleClassName
          )}
          {...framerMotionAnimation}
        >
          <JsxParser
            className={styles.text}
            components={{
              highlight: (data: { children?: React.ReactNode }) => {
                return (
                  <span
                    className={classNames(styles.highlight, {
                      [styles.secondary]: type === "secondary",
                    })}
                  >
                    {data.children}
                  </span>
                );
              },
            }}
            jsx={title}
          />
        </motion.h2>
      )}

      {subtitle && (
        <motion.p
          className={classNames(
            styles.subtitle,
            {
              [styles.secondary]: type === "secondary",
            },
            subtitleClassName
          )}
          {...framerMotionAnimation}
        >
          {subtitle}
        </motion.p>
      )}
    </div>
  );
};

export default Title;
